import React from 'react'


/*

 Replaces <Link to="/smth">link</Link> in text with real Link component

 */

// const text = 'Lorem ipsum dolor <Link to="/smth">link</Link> sit amet, <Link brand toOLD="/smth2">link2</Link>.
const matchLinkInText = (text) => {
  if (!/<Link/.test(text)) {
    return text
  }

  // It uses local require to prevent global cyclical import
  // don't move it outside of the function
  // eslint-disable-next-line global-require
  const Link = require('components/_new/typography/Link/Link').default

  const reg = /<Link[^<]+?<\/Link>/g
  const reg2 = /<Link[^<]+?<\/Link>/
  const textArr = text.split(reg2)

  let process
  let currHrefIndex = 0

  while ((process = reg.exec(text)) !== null) {
    const attrReg       = /\s(\w+?)="(.+?)"/g
    const emptyAttrReg  = /\s(\w+?)(\s+|$)/g
    const href          = process[0]
    const tagContentReg = /<Link(.+?)>/
    const tagContent    = href.match(tagContentReg)[1]
    const emptyAttrs    = tagContent.match(emptyAttrReg) // find empty attributes in tag

    let linkProps = {}
    let text = href.match(/>([^<]+)</)

    text = text ? text[1] : null

    if (emptyAttrs) {
      emptyAttrs
        .map((v) => v.replace(/\s/g, ''))
        .forEach((propName) => {
          linkProps[propName] = true
        })
    }

    // find attributes with values
    while (true) {
      const res = attrReg.exec(tagContent)

      if (res !== null) {
        const [ unmet, propName, propValue ] = res

        linkProps[propName] = propValue
      }
      else {
        break
      }
    }

    textArr.splice(currHrefIndex + 1, 0, React.createElement(Link, {
      ...linkProps,
      key: currHrefIndex + 1,
    }, text))

    currHrefIndex += 2
  }

  return textArr
}


export default matchLinkInText
